import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SearchDropdownVisibleSliceState {
  isVisible: boolean;
}

const initialState: SearchDropdownVisibleSliceState = {
  isVisible: false,
};

export const searchDropdownVisibleSlice = createSlice({
  name: "searchDropdownVisibleSlice",
  initialState,
  reducers: {
    setSearchDropdownVisible: (state, action: PayloadAction<boolean>) => {
      state.isVisible = action.payload;
    },
  },
});

export const { setSearchDropdownVisible } = searchDropdownVisibleSlice.actions;
export default searchDropdownVisibleSlice;
